import { Pipe, PipeTransform } from '@angular/core';

import { isNil } from 'src/utils/utils';

@Pipe({ name: 'isNil' })
export class IsNilPipe implements PipeTransform {
  transform(value: any, is = true) {
    return isNil(value) === is;
  }
}
